module.exports = __webpack_public_path__ + "img/@img_jisike_03.55196483.jpg";